<template>
  <v-dialog
    v-model="show"
    max-width="560"
    persistent
    data-testid="switch-to-beta-prompt">
    <v-card>
      <v-card-title class="d-flex align-start pa-5 pb-2 gap-3">
        <div>
          <div class="text-headline font-weight-bold">
            {{ $t('switchToBeta.prompt.title') }}
          </div>
          <div class="text-body-1 font-weight-regular mt-1">
            {{ $t('switchToBeta.prompt.body') }}
          </div>
        </div>
      </v-card-title>

      <v-card-text class="px-5 pb-3 pt-2">
        <v-alert type="info" colored-border border="left" class="mt-3">
          <i18n path="switchToBeta.prompt.hint" tag="span">
            <template #tryItNow>
              <strong>{{ $t('switchToBeta.prompt.hintTryItNow') }}</strong>
            </template>
            <template #userMenu>
              <strong>{{ $t('switchToBeta.prompt.hintUserMenu') }}</strong>
            </template>
            <template #accountSettings>
              <strong>{{ $t('switchToBeta.prompt.hintAccountSettings') }}</strong>
            </template>
          </i18n>
        </v-alert>
      </v-card-text>

      <v-card-actions class="px-5 pb-4">
        <v-spacer></v-spacer>
        <v-btn text @click="dismiss" data-testid="switch-to-beta-prompt-later-btn">
          {{ $t('switchToBeta.prompt.later') }}
        </v-btn>
        <SwitchToBeta/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SwitchToBeta from './index.vue'
import LocalStorage from 'Store/class/local_storage'

export default {
  name: 'switch-to-beta-prompt',
  components: { SwitchToBeta },
  data () {
    return {
      dismissed: LocalStorage.isCallpanelV2PromptDismissed()
    }
  },
  created () {
    this.getBetaTester()
  },
  computed: {
    ...mapGetters({
      isBetaTester: 'sessions/isBetaTester'
    }),
    show: {
      get () {
        return this.isBetaTester && !this.dismissed
      },
      set (val) {
        if (!val) this.dismiss()
      }
    }
  },
  methods: {
    ...mapActions({
      getBetaTester: 'sessions/getBetaTester'
    }),
    dismiss () {
      LocalStorage.setCallpanelV2PromptDismissed()
      this.dismissed = true
    }
  }
}
</script>

<style scoped>
</style>
